import { Pipe, PipeTransform } from '@angular/core';
import { LinkPresenterModel } from '@osos/shared/types';
import cloneDeep from 'lodash-es/cloneDeep';

@Pipe({
  name: 'searchMenuItems',
  standalone: false,
})
export class SearchMenuItemsPipe implements PipeTransform {
  transform(links: LinkPresenterModel[], filter = ''): LinkPresenterModel[] {
    return cloneDeep(links)
      .map((module) => {
        module.children = module.children?.filter((item) => {
          return (
            Object.keys(item.title).filter(
              (key) =>
                typeof item.title[key] === 'string' &&
                item.title[key]?.toLowerCase().indexOf(filter.toLowerCase()) >
                  -1,
            ).length > 0
          );
        });
        return module;
      })
      .filter((module) => module.children?.length > 0);
  }
}
